import React from "react";
import { connect } from "react-redux";
import { Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import { formValueSelector } from "redux-form";

import { upperFirst } from "lodash";

import moment from "moment";

import { Tooltip } from "../../../core";
import CampaignHeader from "./campaignHeader";
import RouteAllowed from "../../../helper/isRouteAllowed";
import { CardImageWithLoad } from "../../../helper/cardImageWithLoad";
import { CustomCheckBox } from "../../../helper/customCheckBox";
import PhoneBreakpoint from "../../../context/phone_breakpoint";

// eslint-disable-next-line react/no-multi-comp
class GridCampaignView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { handleDelete, roles, permission } = this.props;
    return (
      <div>
        <CampaignHeader
          {...this.props}
          forwardRef={this.props.searchRef}
          refreshing={this.props.refreshing}
          handleRefresh={this.props.handleRefresh}
          handleSearch={this.props.handleSearch}
          handleStatus={this.props.handleStatus}
          handleArchiveItems={this.props.handleArchiveItems}
          handleDeleteCampaigns={this.props.handleDeleteCampaigns}
          disableArchiveIcon={this.props.disableArchiveIcon}
          handleCampaignView={this.props.handleCampaignView}
          userCampaignView={this.props.userCampaignView}
          onSelectAllCampaign={this.onSelectAllCampaign}
        />
        <div className="screenShot_container ">
          <div className="row">
            {" "}
            {this.props.campaignList.length > 0 ? (
              this.props.campaignList.map(item => (
                <div
                  className="col-xs-12
                    col-sm-8
                    col-md-6
                    col-lg-3"
                  key={item.id}
                >
                  <Card className="screenShot_container__screen">
                    <CardBody>
                      <div
                        role="presentation"
                        className="screenShot_container__imageWrapper"
                      >
                        <Link
                          onClick={e => {
                            e.stopPropagation();
                          }}
                          to={{
                            pathname: `/campaign/edit/${item.id}`,
                            state: { name: item.attributes.name || "" }
                          }}
                          className="contentSectionTable__actionButtonWrapperCampaign__buttons"
                        >
                          <div>
                            <CardImageWithLoad
                              url={item.attributes.campaign_thumbnail_large_url}
                            />
                          </div>
                          <PhoneBreakpoint>
                            <CustomCheckBox
                              item={item}
                              selectedList={this.props.campaignsSelected}
                              form="SelectedCampaigns"
                              formField="campaignsSelected"
                              change={this.props.change}
                            />
                          </PhoneBreakpoint>
                          <div
                            className="imageOverlay imageOverlay--mod"
                            style={{
                              bottom:
                                this.props.campaignsSelected.filter(
                                  i => i.id === item.id
                                ).length > 0 && 0
                            }}
                          >
                            <CustomCheckBox
                              item={item}
                              selectedList={this.props.campaignsSelected}
                              form="SelectedCampaigns"
                              formField="campaignsSelected"
                              change={this.props.change}
                            />
                            <div className="actionButtonWrapper actionButtonWrapper--mod">
                              <RouteAllowed
                                roles={roles || []}
                                permission={permission.campaign.show}
                              >
                                <Link
                                  to={{
                                    pathname: `/campaign/show/${item.id}`,
                                    state: { name: item.attributes.name || "" },
                                    params: {
                                      ...item,
                                      handleDelete,
                                      roles,
                                      permission
                                    }
                                  }}
                                  className="contentSectionTable__actionButtonWrapperCampaign__buttons pr-0"
                                  onClick={e => {
                                    e.stopPropagation();
                                  }}
                                >
                                  <Tooltip
                                    item={
                                      <i
                                        className="fa fa-eye "
                                        role="presentation"
                                      />
                                    }
                                    id={`view-${item.id}`}
                                    tooltipContent="View"
                                  />
                                </Link>
                              </RouteAllowed>
                              {item.attributes.status === "live" && (
                                <RouteAllowed
                                  roles={roles || []}
                                  permission={permission.campaign.show}
                                >
                                  <span className="contentSectionTable__actionButtonWrapperCampaign__buttons pr-0">
                                    <Tooltip
                                      item={
                                        <i
                                          className="fa fa-tv "
                                          role="presentation"
                                          onClick={e => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            this.props.handleDisplayPlayingDevices(
                                              item,
                                              true
                                            );
                                          }}
                                        />
                                      }
                                      id={`devices-${item.id}`}
                                      tooltipContent="Currently Playing Devices"
                                    />
                                  </span>
                                </RouteAllowed>
                              )}

                              <RouteAllowed
                                roles={roles || []}
                                permission={permission.campaign.dublicate}
                              >
                                <Tooltip
                                  item={
                                    <i
                                      role="presentation"
                                      onClick={e => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        this.props.handleDuplicate(item.id);
                                      }}
                                      className="fa fa-clone action__clone"
                                    />
                                  }
                                  id={`clone-${item.id}`}
                                  tooltipContent="Duplicate"
                                />
                              </RouteAllowed>
                              <RouteAllowed
                                roles={roles || []}
                                permission={permission.campaign.delete}
                              >
                                <Tooltip
                                  item={
                                    <i
                                      role="presentation"
                                      onClick={e => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        this.props.handleDelete(
                                          item.id,
                                          item.attributes.name
                                        );
                                      }}
                                      className="fa fa-trash"
                                    />
                                  }
                                  id={`delete-${item.id}`}
                                  tooltipContent="Delete"
                                />
                              </RouteAllowed>
                              <RouteAllowed
                                roles={roles || []}
                                permission={permission.archive.campaign}
                              >
                                <Tooltip
                                  item={
                                    <i
                                      role="presentation"
                                      onClick={e => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        this.props.handleArchiveItem(
                                          item.id,
                                          item.attributes.name
                                        );
                                      }}
                                      className="fa fa-archive"
                                    />
                                  }
                                  id={`archive-${item.id}`}
                                  tooltipContent="Archive"
                                  onClick={e => {
                                    e.stopPropagation();
                                  }}
                                />
                              </RouteAllowed>
                            </div>
                            <RouteAllowed
                              roles={roles || []}
                              permission={permission.campaign.show}
                            >
                              <div className="centerAlignedDiv">
                                <span>Edit Campaign</span>
                              </div>
                            </RouteAllowed>
                          </div>
                        </Link>
                      </div>
                      <div className="d-flex screenShot_container__textWrapper">
                        <div className="mr-auto screenShot_container__hostName">
                          {item.attributes.name &&
                          item.attributes.name.length >= 20 ? (
                            <Tooltip
                              item={
                                <span>
                                  {" "}
                                  {`${item.attributes.name.slice(
                                    0,
                                    20
                                  )}...`}{" "}
                                </span>
                              }
                              id={`viewname-${item.id}`}
                              tooltipContent={item.attributes.name}
                            />
                          ) : (
                            <span>{item.attributes.name}</span>
                          )}
                          {!item.attributes.name && <span>N/A</span>}
                        </div>
                        <div className="screenShot_container__buttonsWrapper">
                          <span
                            className={`screenShotButton screenShotButton--mod screenShot_container${
                              item.attributes.status === "live"
                                ? "__activeStatus"
                                : "__offlineStatus"
                            }`}
                          >
                            {item.attributes.status || "N/A"}{" "}
                          </span>
                        </div>
                      </div>

                      <span style={{ fontSize: "14px" }}>
                        {upperFirst(item.attributes.orientation)}
                        {` | `}
                        {item.attributes.updated_at
                          ? `  Updated ${moment
                              .utc(item.attributes.updated_at)
                              .fromNow()}`
                          : "N/A"}{" "}
                      </span>
                    </CardBody>{" "}
                  </Card>{" "}
                </div>
              ))
            ) : (
              <span className="null-message-info">No Data</span>
            )}{" "}
          </div>
        </div>{" "}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const selector = formValueSelector("SelectedCampaigns");
  return {
    campaignsSelected: selector(state, "campaignsSelected") || []
  };
}
export default connect(mapStateToProps)(GridCampaignView);
